<template>
    <div v-if="!isLoading" class="flex" style="height: 608px !important;">
        <div class="flex-1">
            <div class="h-16 border-b-2 border-gray-100 relative">
                <div class="header-class">
                    <div class="rounded-li" style="color: #6B7280;">
                        1
                    </div>
                    <div class="absolute pt-4" style="right: -54px;">
                        <hr style="border-top: 2px solid #f3f4f6; width: 35px; transform: rotate(70deg); margin-bottom: 5.5px;">
                        <br>
                        <hr style="border-top: 2px solid #f3f4f6; width: 35px; transform: rotate(110deg); margin-top: 5.5px;">
                    </div>
                    <div
                        class="ml-6 mt-6"
                        style="width: 142px; height: 20px; font-style: normal; font-weight: 400; font-size: 14px; line-height: 20px; color: #6B7280; flex: none; order: 1; flex-grow: 0;"
                    >
                        Define the Dimensions
                    </div>
                </div>
            </div>
            <div class="component-class overflow-y-auto" style="height: 34rem !important;">
                <DimensionComponent
                    :form-data="dimensionConfig"
                />
                <div class="flex mt-5 mx-auto" style="width:95%">
                    <AdditionalOptionsComponent style="width:100%" />
                </div>
            </div>
        </div>

        <div class="flex-1">
            <div class="h-16 border-b-2 border-gray-100 relative">
                <div class="header-class">
                    <div class="rounded-li" style="color: #6B7280;">
                        2
                    </div>
                    <div class="absolute pt-4" style="right: -54px">
                        <hr style="border-top: 2px solid #f3f4f6; width: 35px; transform: rotate(70deg); margin-bottom: 5.5px;">
                        <br>
                        <hr style="border-top: 2px solid #f3f4f6; width: 35px; transform: rotate(110deg); margin-top: 5.5px;">
                    </div>
                    <div
                        class="ml-6 mt-6"
                        style="width: 142px; height: 20px; font-style: normal; font-weight: 400; font-size: 14px; line-height: 20px; color: #6B7280; flex: none; order: 1; flex-grow: 0;"
                    >
                        Define the Metrics
                    </div>
                </div>
            </div>
            <div class="component-class overflow-y-auto" style="height: 34rem !important;">
                <MetricComponent />
            </div>
        </div>

        <div class="flex-1">
            <div class="h-16 border-b-2 border-gray-100 relative">
                <div class="header-class">
                    <div class="rounded-li" style="color: #6B7280;">
                        3
                    </div>
                    <div
                        class="ml-6 mt-6"
                        style="width: 142px; height: 20px; font-style: normal; font-weight: 400; font-size: 14px; line-height: 20px; color: #6B7280; flex: none; order: 1; flex-grow: 0;"
                    >
                        Additional Filters
                    </div>
                </div>
            </div>
            <div class="flex-1 p-4  border-gray-100 overflow-y-auto overflow-x-hidden " style="height: 33rem !important;">
                <FilterComponent
                    :form-data="formConfig"
                />
            </div>
        </div>
    </div>
    <div v-else class="custom-report-table flex flex-row gap-3">
        <PlaceholderComponent
            v-for="item in 3"
            :key="item"
            :items="1"
            type="table"
        />
    </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { DimensionComponent, MetricComponent, FilterComponent, AdditionalOptionsComponent } from "@GenerateModule/view/"
import { useRoute } from 'vue-router'
import { useStore } from "vuex"
import { PlaceholderComponent } from "@CommonComponents";
import { useReportStore } from "@Store"

export default {
    name: "FormModule",
    components: {
        FilterComponent,
        MetricComponent,
        DimensionComponent,
        PlaceholderComponent,
        AdditionalOptionsComponent
    },
    emits: [ "form-value" ],
    setup() {
        const store = useStore();
        const reportStore = useReportStore();
        const formConfig = ref([]);
        const dimensionConfig = ref([]);
        const route = useRoute();
        const dimensionValue = ref();
        const metricValue = ref();
        const filterValue = ref();
        const isLoading = ref(false);

        onMounted(async () => {
            isLoading.value = true;
            const setupDataRes = await setupData()
            dimensionConfig.value = setupDataRes.dimension
            formConfig.value = setupDataRes
            isLoading.value = (route.params.attribute === 'update' ? true : false);

            if (route.params.attribute === 'update') {
                const getInfoRes = await getInfo(route.params.id)
                reportStore.setDimensions(getInfoRes.dimensionValue)
                reportStore.setMetrics(getInfoRes.metricValue)
                reportStore.setFilters(getInfoRes.filterValue)
                reportStore.setDimensionOption(getInfoRes.dimensionOption)
            }
            isLoading.value = false;
        });

        const getInfo = (async (id) => {
            return await store.dispatch("Reports/getInfo", id);
        })

        const setupData = (async () => {
            return await store.dispatch("Reports/getConfig", window.Subscription)
        })

        return {
            formConfig,
            dimensionConfig,
            dimensionValue,
            metricValue,
            filterValue,
            isLoading
        };
    },
};
</script>
<style lang="scss">
.rounded-li {
    @apply ml-6 rounded-full w-8 h-8 mt-4 flex items-center justify-center border-b-2 border-t-2 border-r-2 border-l-2 border-solid border-gray-400
}
.border-header{
    @apply absolute -right-12 -top-9 h-full text-8xl font-extralight text-gray-100
}
.header-class{
    @apply flex h-full mr-8 relative
}
.component-class{
    @apply flex-1 p-4 mt-2 border-r-2 border-gray-100;
}
</style>
